import { createAction } from "@reduxjs/toolkit";
export const setReplayState = createAction("replay/setState", (payload) => ({
    payload,
}));
export const syncUiInputAction = createAction("ui/sync/input", (payload) => ({
    payload,
}));
export const syncUiScrollAction = createAction("ui/sync/scroll", (payload) => ({
    payload,
}));
export const syncMcaInputAction = createAction("ui/sync/mcaInput", (payload) => ({
    payload,
}));
//# sourceMappingURL=actions.js.map